import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import MobStepper from './MobileStepper';
import { useEffect, useState } from 'react';

import SteLib from 'src/lib/stelib';
import { basename } from '../../configs/EnvironmentConfig';
import moment from 'moment';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

function Carousel() {
  const theme = useTheme();
  const [firstTime, setFirstTime] = useState(true);
  const [activeStep, setActiveStep] = React.useState(0);
  
  const [maxSteps, setMaxSteps] = useState([])
  const [carouselImages, setCarouselImages] = useState([])
  const carouselDirectory = '/images/carousel';

  useEffect(() => {
    if(firstTime)
    {
      SteLib.SimpleGet(basename+"/images/carousel/carousel.json?timestamp="+moment().valueOf()).then((data) => {
        setCarouselImages(data)
        setMaxSteps(data.length)
      })
    }
    setFirstTime(false);
  }, [firstTime]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box sx={{ maxWidth: "100%", flexGrow: 1 }}>
      <Paper
        square
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          //height: 50,
          pl: 2,
          bgcolor: 'background.default',
        }}
      >
        {/*<Typography>{images[activeStep].label}</Typography>*/}
      </Paper>
      <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        interval={3000}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        
      >
        {carouselImages.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <Box
                component="img"
                sx={{
                  height: "auto",
                  display: 'block',
                  overflow: 'hidden',
                  width: '100%',
                }}
                src={`${process.env.PUBLIC_URL}${carouselDirectory}/${step}`}
                //alt={step.label}
              />
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      {/*<MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        
      />*/}
      <MobStepper steps={maxSteps} activeStep={activeStep} onStepClick={currentStep => setActiveStep(currentStep)} />
    </Box>
  );
}


export default Carousel;